import { Component, inject, Input, OnInit } from '@angular/core';
import { DatePipe, NgClass, NgIf } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { OptionDetailsComponent } from '../option-details/option-details.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'mobilize-contract-option',
    imports: [
        NgIf,
        NgClass,
        DatePipe
    ],
    templateUrl: './contract-option.component.html',
    styleUrl: './contract-option.component.scss'
})
export class ContractOptionComponent implements OnInit {

    private _dialog = inject(MatDialog);
    private _device = inject(DeviceDetectorService);

    @Input() option!: any;
    @Input() contractState!: any;
    @Input() contract!: any;

    optionName = '';
    dialogSettings = {};

    ngOnInit() {
        this.optionName = this.option.service_name ? this.option.service_type.servicecategory : this.option.insurance_type;

        if (this.option.insurance_type) {
            this.option.active = this.option.insurance_status === 'Valid';
            this.option.service_end_date = this.option.insurance_end_date;
        }

        if (this._device.isDesktop()) {
            this.dialogSettings = {
                width: '1000px'
            };
        } else {
            this.dialogSettings = {
                maxWidth: '100vw',
                maxHeight: '100vh',
                height: '100vh',
                width: '100vw',
                panelClass: 'full-screen-dialog'
            };
        }
    }

    optionDetails() {
        this._dialog.open(OptionDetailsComponent, {
            ...this.dialogSettings,
            data: {
                option: this.option,
                contract: this.contract,
                name: this.optionName
            },
            autoFocus: false
        });
    }
}
